import m from 'mithril'

import { Howler } from 'howler'

import { removeParam } from 'core/helpers/url-helpers'

class VideoOverlay {
  constructor() {
    this.onVideoEnd = this._onVideoEnd.bind(this)
  }

  oncreate(vnode) {
    let state = this
    Howler.volume(0.05)

    vnode.dom.addEventListener('ended', state.onVideoEnd)
  }

  onremove(vnode) {
    let state = this

    Howler.volume(1.0)

    vnode.dom.removeEventListener('ended', state.onVideoEnd)
  }

  _onVideoEnd() {
    removeParam('overlay')
  }

  view(vnode) {
    return <video className="overlay-info-video" src={vnode.attrs.overlay.src} controls autoplay />
  }
}

export default VideoOverlay
